import { useParams } from "react-router";
import { Chat42Error } from "@/core/error";


export const useScenarioId = () => {
    const { scenarioId } = useParams() as {scenarioId: string};

    if (!scenarioId) {
        throw new Chat42Error("400");
    }
    return scenarioId;
};
